import React from 'react';
import styled from 'styled-components';
import RedCloseIcon from '../../static/icons/red_close.svg';

// Wraps a stimulus pill with a red ✕ that appears on hover (or keyboard focus)
// and removes that one stimulus item. The ✕ is a sibling of the pill, not a
// child, because the pill is itself a <button>.
const RemovableStimulusPill = ({
  label,
  onRemove,
  disabled,
  testId,
  className,
  children,
}) => (
  <PillWrap className={className}>
    {children}
    <RemoveButton
      type="button"
      aria-label={`Remove ${label}`}
      title={`Remove ${label}`}
      data-testid={testId}
      disabled={disabled}
      onClick={(event) => {
        event.stopPropagation();
        onRemove();
      }}
    >
      <img src={RedCloseIcon} alt="" aria-hidden="true" />
    </RemoveButton>
  </PillWrap>
);

export default RemovableStimulusPill;

const RemoveButton = styled.button`
  position: absolute;
  top: -6px;
  right: -6px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  padding: 0;
  border: none;
  border-radius: 50%;
  background: #fff;
  cursor: pointer;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.15s;

  img {
    width: 18px;
    height: 18px;
    display: block;
  }

  &:disabled {
    cursor: progress;
  }

  /* No hover on touch screens: keep the ✕ visible there. */
  @media (hover: none) {
    opacity: 1;
    pointer-events: auto;
  }
`;

const PillWrap = styled.span`
  position: relative;
  display: inline-flex;
  max-width: 100%;

  &:hover ${RemoveButton}, &:focus-within ${RemoveButton} {
    opacity: 1;
    pointer-events: auto;
  }
`;
